import {
  call,
  all,
  put,
  takeLeading,
  takeEvery,
  delay,
  select,
} from 'redux-saga/effects';
import { ActionPalyoad } from 'src/helpers/redux';

import { facebookPixel } from 'src/services/analytics/providers/FacebookPixel';
import { analyticsEvents, ESubscriptionReason } from 'src/services/analytics/events';
import { IResponse } from 'src/services/RomanticAI/http';
import * as paymentService from 'src/services/RomanticAI/payment';

import { setSession } from 'src/services/RomanticAI/session';
import {
  setFinpaymePendingInvoice,
  getFinpaymePendingInvoice,
  clearFinpaymePendingInvoice,
} from 'src/services/RomanticAI/payment/finpayme';
import * as accountStore from 'src/redux/modules/account';
import * as dialogStore from 'src/redux/modules/dialog';

import { actions } from './actions';
import { setters } from './index';
import { getHeartProduct } from 'src/services/RomanticAI/products'
import queryString from 'query-string';

export default function* sagas() {
  yield all([
    takeLeading(
      actions.postCreateCheckoutSession.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.postCreateCheckoutSession.pending>
      ) {
        try {
          const { price_id, dialogId, message_id, reason, is_old, is_upgrade, paywall_name, priority_category,botName } = action.payload;
          const pathname = dialogId ? `chats/${dialogId}` : '';
          const query = queryString.stringify({
            modal: "subscription",
            dialogId,
            message_id,
            reason,
            is_upgrade,
            priority_category,
            botName
          })

          const redirectUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''
            }/${pathname}?${query}`;

          const payload = btoa(JSON.stringify({
            redirectUrl
          })).replace('eyJ','egI')


          const success_url = `${window.settings.MIRROR_CHECKOUT_SESSION_URL}/?checkout-session-success=${payload}`;

          const bot: dialogStore.IStateData['bot'] = yield select(
            dialogStore.selectors.bot
          );

          try {
            setSession({ superOffer: undefined })
            analyticsEvents.subscriptionCheckout({
              reason: reason as ESubscriptionReason,
              bot_name: botName || '',
              bot_category: priority_category,
            })

          } catch (e) {
            console.error(e)
          }
          const metadata:paymentService.IPostCreateCheckoutSessionParams['metadata'] = {
            bot_chat_user_id:dialogId,
            reason: reason || '',
            paywall_name: paywall_name,
          }

          const checkoutSession: IResponse<paymentService.IPostCreateCheckoutSessionData> =
            yield call(paymentService.postCreateCheckoutSession, {
              price_id,
              success_url: success_url,
              is_old,
              is_upgrade,
              metadata
            });

          if (checkoutSession.data.url){
            if (is_upgrade){
              const payload = btoa(JSON.stringify({
                redirectUrl:checkoutSession.data.url
              })).replace('eyJ','egI')


              const success_url = `${window.settings.MIRROR_CHECKOUT_SESSION_URL}/?checkout-session-success=${payload}`;

              window.open(success_url)
            } else {
              // yield delay(500);
              const data = btoa(JSON.stringify(checkoutSession.data))
              window.location.replace(`${window.settings.MIRROR_CHECKOUT_SESSION_URL}?checkout-session=${data}`);
            }
          }

          yield put(accountStore.actions.accountSetup.pending())
          yield put(actions.postCreateCheckoutSession.fulfilled());
        } catch (error) {
          yield put(actions.postCreateCheckoutSession.rejected(error as Error));
        }
      }
    ),

    takeLeading(
      actions.postCreatePortalSession.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.postCreatePortalSession.pending>
      ): Generator<any, void, any> {
        try {
          const { price_id, reason } = action.payload;
          
          // [stripe-portal] 1. Фронт → Бекенд: POST /payments/create-portal-session
          // [stripe-portal] 2. Бекенд → Stripe API: Создает portal session
          // [stripe-portal] 3. Stripe → Бекенд: Возвращает portal URL
          // [stripe-portal] 4. Бекенд → Фронт: { url: "https://billing.stripe.com/..." }
          
          // Автоматический выбор первого продукта, если price_id не передан
          let selectedPriceId = price_id;
          if (!selectedPriceId) {
            const productsGroups: any = yield select((state: any) => state.payment.data.productsGroups);
            const subscriptionProducts = productsGroups.subscriptions
              .filter((product: any) => product?.info?.enable)
              .sort((a: any, b: any) => a.info.priority_index - b.info.priority_index);
            
            if (subscriptionProducts.length > 0) {
              selectedPriceId = subscriptionProducts[0].payments.stripe.prices[0].stripe_price_id;
            }
          }
          
          const redirectUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/profile`;
          
          const payload = btoa(JSON.stringify({
            redirectUrl
          })).replace('eyJ','egI')

          const success_url = `${window.settings.MIRROR_CHECKOUT_SESSION_URL}/?portal-session-success=${payload}`;

          const metadata: paymentService.IPostCreatePortalSessionParams['metadata'] = {
            reason: reason || 'subscription_edit',
          }

          const portalSession: IResponse<paymentService.IPostCreatePortalSessionData> =
            yield call(paymentService.postCreatePortalSession, {
              price_id: selectedPriceId || 'no-price-id',
              success_url: success_url,
              metadata
            });

          if (portalSession.data.url) {
            // [stripe-portal] 5. Фронт → aiversations.com: ?portal-session=encoded_url
            const data = btoa(JSON.stringify(portalSession.data))
            window.location.replace(`${window.settings.MIRROR_CHECKOUT_SESSION_URL}?portal-session=${data}`);
          }

          yield put(accountStore.actions.accountSetup.pending())
          yield put(actions.postCreatePortalSession.fulfilled());
        } catch (error) {
          yield put(actions.postCreatePortalSession.rejected(error as Error));
        }
      }
    ),

    takeLeading(
      actions.postHeartCreateCheckoutSession.pending.toString(),
      function* (
        action: ActionPalyoad<
          typeof actions.postHeartCreateCheckoutSession.pending
        >
      ) {
        try {
          const { price_id, dialogId, reason, count, message_id, botName, bot_category } = action.payload;
          const query = queryString.stringify({
            modal: "paywall-heart-result",
            dialogId,
            message_id,
            reason,
            count,
            bot_category,
            botName,
            price_id
          })
          const pathname = dialogId ? `chats/${dialogId}` : '';
          const redirectUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''
            }/${pathname}?${query}`;

          const payload = btoa(JSON.stringify({
              redirectUrl
            })).replace('eyJ','egI')

          const success_url = `${window.settings.MIRROR_CHECKOUT_SESSION_URL}/?checkout-session-success=${payload}`;

          const metadata:paymentService.IPostCreateCheckoutSessionParams['metadata'] = {
            bot_chat_user_id:dialogId,
            reason: reason || '',
            paywall_name: 'hearts',
          }
          const checkoutSession: IResponse<paymentService.IPostCreateCheckoutSessionData> =
            yield call(paymentService.postCreateCheckoutSession, {
              price_id,
              success_url: success_url,
              metadata,
            });
            analyticsEvents.coinsCheckout({
              reason: reason as ESubscriptionReason,
              bot_name: botName || '',

              bot_category: bot_category,
            })

          const data = btoa(JSON.stringify(checkoutSession.data))
          window.location.replace(`${window.settings.MIRROR_CHECKOUT_SESSION_URL}?checkout-session=${data}`);

          yield put(actions.postHeartCreateCheckoutSession.fulfilled());
        } catch (error) {
          yield put(
            actions.postHeartCreateCheckoutSession.rejected(error as Error)
          );
        }
      }
    ),
    takeLeading(
      actions.getProducts.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.getProducts.pending>
      ) {
        try {
          const products: IResponse<paymentService.IGetProductsData> =
            yield call(paymentService.getProducts, 'paypal');
          yield put(setters.setProducts({ provider: 'paypal', data: products.data }))
          yield put(actions.getProducts.fulfilled());
        } catch (error) {
          yield put(
            actions.getProducts.rejected(error as Error)
          );
        }
      }
    ),
    takeLeading(
      actions.getPaymentOptions.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.getPaymentOptions.pending>
      ) {
        try {
          const options: IResponse<paymentService.IGetPaymentOptionsData> =
            yield call(paymentService.getPaymentOptions);
          yield put(setters.setPaymentOptions(options.data));
          yield put(actions.getPaymentOptions.fulfilled());
        } catch (error) {
          yield put(actions.getPaymentOptions.rejected(error as Error));
        }
      }
    ),
    takeLeading(
      actions.getFinpaymeProducts.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.getFinpaymeProducts.pending>
      ) {
        try {
          const products: IResponse<paymentService.IGetProductsData> =
            yield call(paymentService.getProducts, 'finpayme');
          yield put(setters.setProducts({ provider: 'finpayme', data: products.data }));
          yield put(actions.getFinpaymeProducts.fulfilled());
        } catch (error) {
          yield put(actions.getFinpaymeProducts.rejected(error as Error));
        }
      }
    ),
    takeLeading(
      actions.postFinpaymeInvoice.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.postFinpaymeInvoice.pending>
      ) {
        try {
          const { product_id, product_type, payment_method, consumables } = action.payload;

          yield put(setters.setFinpaymeInvoiceError(undefined));

          const wallet: accountStore.IStateData['wallet'] = yield select(
            accountStore.selectors.wallet
          );
          const subscription: accountStore.IStateData['subscription'] = yield select(
            accountStore.selectors.subscription
          );

          const return_url = `${location.protocol}//${location.hostname}${
            location.port ? ':' + location.port : ''
          }/?modal=finpayme-result`;

          const invoice: IResponse<paymentService.IPostFinpaymeInvoiceData> =
            yield call(paymentService.postFinpaymeInvoice, {
              product_id,
              return_url,
              payment_method,
            });

          setFinpaymePendingInvoice({
            invoice_id: invoice.data.invoice_id,
            product_type,
            consumables,
            balance_before: wallet?.balance,
            expires_at_before:
              subscription?.payment_provider === 'finpayme'
                ? subscription?.expires_at
                : undefined,
          });

          window.location.href = invoice.data.url;

          yield put(actions.postFinpaymeInvoice.fulfilled());
        } catch (error) {
          const status = (error as { response?: { status?: number } })?.response?.status;
          const errorCode = (
            error as { response?: { data?: { error_code?: string } } }
          )?.response?.data?.error_code;

          if (errorCode === 'PROVIDER_UNAVAILABLE' || errorCode === 'SUBSCRIPTION_CONFLICT') {
            yield put(setters.setFinpaymeInvoiceError(errorCode));
            yield put(actions.getPaymentOptions.pending());
          } else if (status === 400) {
            yield put(setters.setFinpaymeInvoiceError('INVALID_PRODUCT'));
            yield put(actions.getFinpaymeProducts.pending());
          } else {
            yield put(setters.setFinpaymeInvoiceError('UNKNOWN'));
          }

          yield put(actions.postFinpaymeInvoice.rejected(error as Error));
        }
      }
    ),
    takeLeading(
      actions.finpaymeAwaitResult.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.finpaymeAwaitResult.pending>
      ) {
        try {
          const pendingInvoice = getFinpaymePendingInvoice();

          if (!pendingInvoice) {
            yield put(setters.setFinpaymeResult(undefined));
            yield put(actions.finpaymeAwaitResult.fulfilled());
            return;
          }

          const { product_type, consumables, balance_before, expires_at_before } =
            pendingInvoice;

          const POLL_INTERVAL = 2500;
          const POLL_ATTEMPTS = 24;

          let isCredited = false;

          for (let attempt = 0; attempt < POLL_ATTEMPTS; attempt++) {
            try {
              if (product_type === 'ONE_TIME') {
                const wallet: IResponse<paymentService.IGetWalletData> =
                  yield call(paymentService.getWallet);

                if (wallet.data.balance > (balance_before || 0)) {
                  yield put(accountStore.setters.setWallet(wallet.data));
                  isCredited = true;
                }
              } else {
                const subscription: IResponse<paymentService.IGetSubscriptionData> =
                  yield call(paymentService.getSubscription);

                if (
                  subscription.data.payment_provider === 'finpayme' &&
                  (!expires_at_before ||
                    subscription.data.expires_at !== expires_at_before)
                ) {
                  yield put(accountStore.setters.setSubscription(subscription.data));
                  isCredited = true;
                }
              }
            } catch (error) {}

            if (isCredited) break;

            yield delay(POLL_INTERVAL);
          }

          clearFinpaymePendingInvoice();

          yield put(
            setters.setFinpaymeResult({
              status: isCredited ? 'success' : 'processing',
              product_type,
              consumables,
            })
          );
          yield put(actions.finpaymeAwaitResult.fulfilled());
        } catch (error) {
          clearFinpaymePendingInvoice();
          yield put(actions.finpaymeAwaitResult.rejected(error as Error));
        }
      }
    ),
    takeLeading(
      actions.getProductsGroups.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.getProductsGroups.pending>
      ) {
        try {
          const products: IResponse<paymentService.IGetProductsGroupsData> =
            yield call(paymentService.getProductsGroups, action.payload);

          yield put(setters.setProductsGroups(products.data))

          yield put(actions.getProductsGroups.fulfilled());
        } catch (error) {
          yield put(
            actions.getProductsGroups.rejected(error as Error)
          );
        }
      }
    ),
    takeLeading(
      actions.stripeChange.pending.toString(),
      function* (
        action: ActionPalyoad<typeof actions.stripeChange.pending>
      ) {
        try {
          const { price_id, extra } = action.payload
          const suabscription:accountStore.IStateData['subscription'] = yield select(accountStore.selectors.subscription)

          if (suabscription?.price_id === price_id || !extra?.reason) {
            yield put(actions.stripeChange.fulfilled());
            return;
          }

          const pathname = extra.bot_id ? `chats/${extra.bot_id}` : '';
          const query = queryString.stringify({
            modal: "subscription",
            dialogId:extra.bot_id,
            reason: extra.reason,
            priority_category: extra.bot_category,
            botName: extra.bot_name
          })

          const redirectUrl = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''
            }/${pathname}?${query}`;

          window.location.replace(redirectUrl);

          yield put(actions.stripeChange.fulfilled());
        } catch (error) {
          yield put(
            actions.stripeChange.rejected(error as Error)
          );
        }
      }
    ),

  ]);
}